import React, { Component } from 'react';

import { isFunction, isEmpty } from 'lodash';

import { inject, observer } from 'mobx-react';
import { Select, Icon } from 'antd';

import './SubscriptionTypeFilter.css';

@inject('translationsStore', 'subscriptionsStore', 'filterStore')
@observer
export default class SubscriptionTypeFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  selectSubscriptionType = subscriptionType => {
    this.setState({ subscriptionTypeSelected: subscriptionType });
    this.props.filterStore.add('subscriptionFilter_subscriptionType', subscription => subscription.subscriptionType && subscription.subscriptionType.name === subscriptionType);
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        subscriptionTypeSelected: null
      });
    }
  };

  render() {
    const { translationsStore, status } = this.props;
    const { subscriptionTypeSelected } = this.state;

    return (
      <div className="SubscriptionTypeFilter" id="SubscriptionTypeFilter">
        <div className="filterTitle">
          {translationsStore.translate('subscriptionManager.filter.subscriptionType')}

          <span>
            {!isEmpty(subscriptionTypeSelected) && status !== false && (
              <span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="selected">{translationsStore.translate(`subscriptionManager.types.${subscriptionTypeSelected}`)}</div>
                  <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.reset} />
                </div>
              </span>
            )}
          </span>
        </div>
        <Select value={subscriptionTypeSelected} onChange={this.selectSubscriptionType}>
          {this.props.subscriptionsStore.subscriptionTypes.map(subscription => (
            <Select.Option value={subscription} key={subscription}>
              {translationsStore.translate(`subscriptionManager.types.${subscription}`)}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionAdvancedFilter/filters/SubscriptionTypeFilter/SubscriptionTypeFilter.js